export default "__VITE_ASSET__J9g$hOQ5__"